/**
 * A handy dandy file of strings used in the Export Template feature folder,
 * all bunched together for easy editing when product owners decide to change
 * the copy of some component.
 */

export const listTab = {
  createNewTemplate: 'Create Export Template',
  templateFetchErrorEdit: 'Failed to load template details',
  templateFetchErrorSettings: 'Failed to load template settings',
  templateSettings: 'Template Settings',
  templateDelete: 'Delete Template',
  deleteConfirmBody: name =>
    `Are you sure you want to delete ${name || 'this template'}?`,
  deleteModalTitle: name => `Delete ${name || 'Template'}`,
  deleteSelectedTitle: 'Delete Selected Templates',
  bulkDeleteConfirmBody: count =>
    `Are you sure you want to delete ${count} template${count > 1 ? 's' : ''}?`,
  confirm: 'Yes',
  description:
    'Export templates define which fields are included when exporting data and can be reused across contact and organisation searches',
  deleteSelected: 'Delete Selected',
  edit: 'Edit',
  searchPlaceholder: 'Search',
  dateRangePlaceholder: 'Date Range',
  startDatePlaceholder: 'Start date',
  endDatePlaceholder: 'End date',
  selectedCount: count => `${count} Selected`,
  deselectAll: 'Deselect All',
};

export const favourites = {
  tooltipActive: 'Remove as favourite',
  tooltipSet: 'Set as favourite',
  tooltipLoading: 'Updating favourite template...',
  errorTitle: 'Failed to update favourite template.',
  errorDescription: 'Please try again.',
  removeSuccessTitle: 'Favourite Template Removed',
  successTitle: 'Favourite Template Updated',
  successDescription: name => (
    <>
      The template named <strong>{name}</strong> is now your favourite. This
      template will appear at the top of your templates list when exporting.
    </>
  ),
};

export const modalHeader = {
  createExportTemplate: 'Create Export Template',
  templateSettings: 'Template Settings',
  customise: name => `Customise '${name}'`,
  unsavedChanges: 'Unsaved changes will be lost',
};

export const columnEditor = {
  searchPlaceholder: 'Search fields',
  deselectAll: 'Deselect All',
  enableAll: 'Select All',
  emailLockedTooltip:
    'Email is locked by the Hide Emails restriction on your account.',
  confirm: 'Confirm',
};

export const columnName = {
  originalName: name => `SciLeads default: ${name}`,
  edited: 'Edited',
};

export const sheetName = {
  originalName: name => `SciLeads default: ${name}`,
  edited: 'Edited',
};

export const revertableInput = {
  revertTooltip: value => `Revert to "${value}"`,
  confirmTooltip: value => `Confirm "${value}"`,
  cancelTooltip: 'Cancel edit',
};

export const save = {
  templateName: 'Template Name',
  namePlaceholder: 'Type the name of your new Export Template',
  share: 'Share',
  shareDescription: 'Shared templates can be used by other team members',
  tabsIncluded: (enabled, total) => `of ${total} tabs Included`,
  fieldsIncluded: (enabled, total) => `of ${total} fields included`,
  itemsRenamed: 'Items renamed',
  back: 'Back',
  cancel: 'Cancel',
  confirm: 'Confirm',
  createTemplate: 'Create Template',
  saveTemplate: 'Save Template',
  unsavedChangesTitle: 'Unsaved changes',
  unsavedChangesContent: `Are you sure you want to close the Customise Fields process. Any changes you've made will be lost.`,
  unsavedChangesOk: 'Yes, close',
  unsavedChangesCancel: 'No, stay',
  warningNoColumns: 'Please include at least one sheet with columns',
};

export const templateEditor = {
  fieldsSelected: (selected, total) =>
    `${selected} of ${total} fields selected`,
  editColumns: 'Edit Columns',
  oneTimeExport: 'One-Time Export',
  cannotOverwrite: 'You cannot overwrite a shared template',
  update: 'Update',
  saveNew: 'Save New',
};
